import {
  ClientMenuItemDto,
  ClientLocationDto,
  AdvertisingBannerDto,
  ClientMenuCategoryDto,
} from '../store/api/restApi';
import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { createContext, useContext, ReactNode, Dispatch, SetStateAction } from 'react';

export type CatalogData = {
  locations: ClientLocationDto[];
  isCatalogLoading: boolean;
  menuItems: ClientMenuItemDto[];
  banners: AdvertisingBannerDto[];
  categories: ClientMenuCategoryDto[];
  catalogError: FetchBaseQueryError | SerializedError | undefined;
  reservationUrl: string | undefined;

  isBasketFetching: boolean;
  chainInfoRefetch: VoidFunction;
  locationsRefetch: VoidFunction;
  menuItemsRefetch: VoidFunction;
  categoriesRefetch: VoidFunction;
  setIsInitialMenuRefetch: Dispatch<SetStateAction<boolean>>;
  setIsInitialCategoriesRefetch: Dispatch<SetStateAction<boolean>>;
};

const CatalogDataContext = createContext<CatalogData | null>(null);

export const CatalogDataProvider = ({ children, data }: { children: ReactNode; data: CatalogData }) => (
  <CatalogDataContext.Provider value={data}>{children}</CatalogDataContext.Provider>
);

// eslint-disable-next-line react-refresh/only-export-components
export const useCatalogData = () => {
  const context = useContext(CatalogDataContext);
  if (!context) throw new Error('useCatalogData used outside provider');
  return context;
};
